import { Badge, Table } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { User } from '../model/UserTypes';
import { LocalAccountReissueButton } from './LocalAccountReissueButton';

interface LocalAccountTableProps {
  users: User[];
}

export function LocalAccountTable({ users }: LocalAccountTableProps) {
  const { t } = useTranslation();

  return (
    <Table.ScrollContainer minWidth={800}>
      <Table
        striped
        highlightOnHover
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t('localAccounts.columns.email')}</Table.Th>
            <Table.Th>{t('localAccounts.columns.name')}</Table.Th>
            <Table.Th>{t('localAccounts.columns.roles')}</Table.Th>
            <Table.Th>{t('localAccounts.columns.status')}</Table.Th>
            <Table.Th />
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {users.map(user => (
            <Table.Tr key={user.id}>
              <Table.Td>{user.email}</Table.Td>
              <Table.Td>{`${user.lastName} ${user.firstName}`}</Table.Td>
              <Table.Td>{user.roles.map(role => t(`roleType.${role}`)).join(', ')}</Table.Td>
              <Table.Td>
                {user.passwordChangeRequired ? (
                  <Badge color="orange">{t('localAccounts.status.passwordChangeRequired')}</Badge>
                ) : (
                  <Badge color="green">{t('localAccounts.status.active')}</Badge>
                )}
              </Table.Td>
              <Table.Td>
                <LocalAccountReissueButton user={user} />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
